/* Struktura powinna być jednolita w obu frontendach */
export class Config {
    technicalMessage: {
        level: string,
        message: string
    }
    loginEnabled: boolean
}